bq.helper = {
  uniqueIdCounter: 0,
  scrolling: false,
  stickyVisible: false,
  waitingForInitSelect2List: [],

  // detects if mobile device
  // use by bq.helper.mq.is('xs')
  mq: {
    breakpoints: {
      xs    : '(max-width: 767px)',
      sm    : '(min-width: 768px)',
      md    : '(min-width: 992px)',
      lg    : '(min-width: 1200px)',
      xl    : '(min-width: 1300px)'
    },

    is: function(breakpoint) {
      return Modernizr.mq(this.breakpoints[breakpoint]);
    }
  },


  checkLongWait: function(el) {
    if($(el).hasClass('trigger-view-handler-on-click')) {
      bq.helper.throwEvent('bq.viewhandler.progressmessage', $(el), {message: bq.messages.global.loadingLongWait});
    }
  },

  // remove
  arrayRemove: function(arr, rem) {
    var position = $.inArray(rem, arr);
    if ( position != -1 ) {
      return arr.splice(position, 1);
    }
    return arr;
  },


  // gives an element a unique id (if it doesnt have an id)
  // at return id
  uniqueId: function(el, pre) {
    var $id = $(el).attr('id');
    if ($id) {
      return $id;
    } else {
      var prefix = pre ? pre : 'bq-ui-';
      $(el).attr('id', prefix + ( ++this.uniqueIdCounter ));
      return $(el).attr('id');
    }
  },

  trim: function(str) {
    return str.replace(/^\s+|\s+$/g,"");
  },

  toggleDropdown: function(el) {
    var $el = el;
    setTimeout(function(){$($el).addClass('open');}, 30);
  },

  throwEvent: function(eventToThrow, el, opt) {
    el = el === 'data-view-handler' ? $('[data-view-handler]') : el || $(document);
    bq.debug.log("Global : event thrown ["+eventToThrow+"]", el);
    if (el[0]) {//@TODO: need to refactoring
        var event = new CustomEvent(eventToThrow, {detail: opt});
        el[0].dispatchEvent(event);
    }
    el.trigger(eventToThrow, opt);
  },

  toggleCheckbox: function(sel, silent, checkedDuplicate) {
    $(sel).prop("checked", !$(sel).prop("checked"));
    if(checkedDuplicate){
      $(sel + '_1').prop("checked", !$(sel + '_1').prop("checked"));
      $('[data-bq="toggle-compare"]').each(function(){
        if ($(this).prop('checked')) {
          $(this).parents('.input-parent').addClass('checked');
        } else {
          $(this).parents('.input-parent').remove('checked');
        }
      })
    }
    if(!silent) {
      $(sel).change();
    }
    return $(sel).prop("checked");
  },

  toggleDocumentDetail: function(el) {
    var $el = el;
    if($($el).hasClass('trigger-summary-view')){
        $('.doc-item-row.details').removeClass('open');
        $('.doc-item-row.summary').addClass('open');
    } else {
        $('.doc-item-row.details').addClass('open');
        $('.doc-item-row.summary').removeClass('open');
    }
  },


  fileSize: function (bytes, pre) { //return human readable filesize
    pre = pre ? pre : '';
    if (isNaN(bytes) || bytes === 0) { return pre+"0.00 B"; }
    var e = Math.floor(Math.log(bytes) / Math.log(1024));
    return pre+(bytes/Math.pow(1024, e)).toFixed(2)+''+' KMGTP'.charAt(e)+'B';
  },

  fillData: function(el, data, mode) {

    $.each(data, function(k, v){
        var tmp = el.find('[data-'+k+']');
        if(!mode || mode === 'html') {
            tmp.html(v);
        } else if(mode === 'text') {
            tmp.text(v);
        }
    });

    return el;
  },

  selectChangeHide: function(el) {
    var $el = $(el);

    if($el.data('hide')) {
       $($el.data('hide')).addClass('hide');
    }

    if($el.is('select')) {
        var $selected = $('[value="'+$el.val()+'"]', $el);

        if($selected.data('hide')) {
            $($selected.data('hide')).addClass('hide');
        }

        if($selected.data('show')) {
            $($selected.data('show')).removeClass('hide');
        }
    }
  },

  showAndHide: function (show, hide) {
    if(show) {
        $(show).removeClass('hide');
    }

    if(hide) {
        $(hide).addClass('hide');
    }
  },

  updateInput: function(textEl, inputEl) {
    textEl = $(textEl);
    inputEl = $(inputEl);

    if(!textEl || !inputEl) { return; }

    if(textEl.hasClass('input-blank')) {
      inputEl.val('');
    } else {
      inputEl.val(textEl.text());
    }

  },

  swapData: function(one, two, link) {
    one = $(one);
    two = $(two);
    link = $(link);

    if(one.hasClass('hide')) {
      bq.helper.showAndHide(one, two);
      if(link.data('one')) {
        link.text(link.data('one'));
      }
    } else {
      bq.helper.showAndHide(two, one);
      if(link.data('two')) {
        link.text(link.data('two'));
      }
    }
  },

  checkAll: function(parent, el, check, trigger) {
    var box = $(parent).find('input[type="checkbox"]:enabled');
    box.prop('checked', check);
    if (trigger) {
      box.trigger('change');
    }
    if (el) {
      var $el = $(el);
      check = check ? 'false' : 'true';
      if ($el.data('check') && $el.data('uncheck')) {
        $el.attr("onclick", "javascript:bq.helper.checkAll('" + parent + "', this, " + check + ", " + trigger + ");");
        if (check == 'true') {
          $el.text($el.data('check'));
        } else {
          $el.text($el.data('uncheck'));
        }
      }
    }
  },

  moveDivLeft: function(el, target, offset, offsetObject) {

    function calculateTargetPosition(el, target, offset, offsetObject){

      if( $(offsetObject).length && $(offsetObject).is(":visible") ) {
        offsetObject = -Math.abs( parseInt($(offsetObject).width() + $(offsetObject).offset().left) );
      } else {
        offsetObject = 0;
      }

      offset = offset ? offset : 0;
      el = $(el);
      target = $(target);
      if(el && target) {
        target.css({'left': (el.offset().left + offset + offsetObject) +'px'});
      }
    }

    calculateTargetPosition(el, target, offset, offsetObject);

    $(window).off('resize.bq.moveDivLeft').on('resize.bq.moveDivLeft', function(){
      calculateTargetPosition(el, target, offset, offsetObject);
    });

    return true;
  },

  updateTooltip: function(el, title, options) {
    options = typeof options !== 'undefined' ? options : {};
    if(!el || !title) { return; }
    el = $(el);

    if(el.tooltip()) {
      //it exists, lets update it
      el.attr('title', title).tooltip('fixTitle');
    } else {
      //doesnt exist, lets create
      el.attr('title', title);
      //bug in bootstrap wont let me send options
      //to the tooltip, you might have to set manually
      //until fixed
      el.tooltip(options);
    }
  },

  updateValue: function($selector, $val) {
    $($selector+':input').val($val);
    $('span'+$selector+', div'+$selector).text($val);
  },

  smoothScroll: function(el) {
    if(this.scrolling) { return; }
    el = $(el);
    if(el.length <= 0) { return; }

    this.scrolling = true;
    var $this = this;

    $('html,body').animate({
      scrollTop: el.offset().top
    }, 1000, function(){ $this.scrolling = false; });

  },

  stickyBanner: function(){

      $('[data-sticky-banner]').each(function(){
        var $el = this,
            $parent = $($el).parent();
        var icon = '';
        var status = $($el).attr('data-banner-type');

        if($el !== '' && $($el).not(':visible')){
            $($el).addClass(status);

            switch(status){
                case 'success':
                    icon = 'fa fa-check';
                    break;
                case 'warning':
                    icon = 'fa fa-exclamation';
                    break;
                default:
                    icon = 'fa fa-info';
            }

            $($el).children('.icon').addClass(icon);

            $($el).insertBefore('.container .row:first-child');
            $($el).css('display','inline-block');

            $(window).on('scroll', bq.helper.debounce(function (e) {
                var posOfEl = $($el).offset().top,
                    heightOfEl = $($el).height(),
                    scrollPos = $(window).scrollTop();

                if (scrollPos > (posOfEl + heightOfEl)) {
                    if($('.clone').length == 0){
                        $($el).clone().addClass('clone').insertAfter($($el));
                        $('.clone').addClass('animated fadeIn');
                    }
                    self.stickyVisible = true;
                } else {
                    $('.clone').removeClass('animated fadeIn').remove();
                    self.stickyVisible = false;
                }
            }, 5))
        };


    });
  },

  getDatepickerDate: function(value) {
    var result = null;
    if(value) {
      $('input').each(function() {
        if(result === null) {
          var $input = $(this);
          if($input.val() == value && $input.data('datepicker')) {
            result = $input.datepicker('getDate');
          }
        }
      });
    }
    return result;
  },

  templateEngine: {
    compile: function(template) {
      return {
        render: function(context) {
          return template.replace(/\{\{(\w+)\}\}/g,
            function(match, p1) {
              var text = context[p1] || '';
              if(text == '' && p1.indexOf("__") != -1) {
                var t = p1.split("__");
                switch(t.length) {
                  case 1:
                    text = context[t[0]];
                    break;
                  case 2:
                    text = context[t[0]][t[1]];
                    break;
                  case 3:
                    text = context[t[0]][t[1]][t[3]];
                    break;
                  case 4:
                    text = context[t[0]][t[1]][t[3]][t[4]];
                    break;
                  default:
                    break;
                }
              }
              if(typeof text !== 'string') { text = ''; }
              return jQuery('<div/>').html(text).html();
            });
        }
      };
    }
  },

  checkForm: function(url, form) {
    form = $(form);

    var els = $('.has-warning, .has-error', form);

    if(els.length >= 1) {
      try {
        var tp =  $('.form-control-feedback',els[0]).tooltip('show');

        e.stopPropagation();
        e.preventDefault();
      } catch(ex) {}
    } else {
      window.location = url;
    }

  },

  redraw: function(elem) {
    elem = $(elem);
    elem.hide().show(0);
  },

  now: Date.now || function() { return new Date().getTime(); },

  debounce: function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = bq.helper.now() - timestamp;
      if (last < wait) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = bq.helper.now();
      var callNow = immediate && !timeout;
      if (!timeout) {
        timeout = setTimeout(later, wait);
      }
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  },

  formToObject: function(form){
      var o = {};
      var a = $(form).serializeArray();
      var $this = this;
      var isFilterForm = form.closest('.filter-content-container').length > 0;

      if(a.length === 0 && !$(form).is('form')) {
        a = $(':input', $(form)).serializeArray();
      }

      if($(form).data('type') === 'quick-order-bundle'){
          $('input[type=checkbox], input[type=radio]', form).each(function(){
              var input = {name: this.name, value: this.checked};
              a.push(input);
          });
      }

      $.each(a, function() {
          var nameParts = this.name.split('[');
          if (nameParts.length == 1) {
              // New value is not an array - so we simply add the new
              // value to the result object
              if (o[this.name] !== undefined) {
                  if (!o[this.name].push) {
                      o[this.name] = [o[this.name]];
                  }
                  o[this.name].push(this.value || '');
              } else {
                  o[this.name] = this.value || '';
              }
          }
          else {

            if(nameParts[0] != 'hidden'){
              // New value is an array - we need to merge it into the
              // existing result object
              $.each(nameParts, function (index) {
                  nameParts[index] = this.replace(/\]$/, '');
              });

              // This $.each merges the new value in, part by part
              var arrItem = this;
              var temp = o;
              $.each(nameParts, function (index) {
                  var next;
                  var nextNamePart;

                  if (index >= nameParts.length - 1)
                      next = arrItem.value || '';
                  else {
                      nextNamePart = nameParts[index + 1];
                      if ($this.trim(this) !== '' && temp[this] !== undefined)
                          next = temp[this];
                      else {
                          if ($this.trim(nextNamePart) === '')
                              next = [];
                          else
                              next = {};
                      }
                  }

                  if ($this.trim(this) === '') {
                      if (isFilterForm && !Array.isArray(next) && next.indexOf(',') >= 0) {
                          var nextArray = next.split(',');
                          $.each(nextArray, function(){
                              temp.push(this);
                          });
                      } else {
                          temp.push(next);
                      }
                  } else
                      temp[this] = next;

                  temp = next;
              });
            }
          }
      });
      return o;
  },

  formToCompressedData: function(form){
    return {
      data_compressed: btoa(form.serialize())
    };
  },

  collaborateCart: function(){
      $('#collaborative_cart_create_modal_toggle').click();
  },

  itemToForm: function(parent, item, elementPrefix) {
    var name = elementPrefix;

    if(typeof(item) === 'string') {
      parent.append('<input type="hidden" name="'+name+'" value="'+item+'">');
    } else {
      $.each(item, function(index, value) {
        bq.helper.itemToForm(parent, value, name+'['+index+']');
      });
    }
  },

  highlight: {
    defaults: {
      node: null,
      pattern: null,
      tagName: 'mark',
      className: null,
      wordsOnly: false,
      caseSensitive: false
    },
    o: {},
    regex: '',
    run: function(o) {
      this.o = $.extend({}, this.defaults, o);

      if (!o.node || !o.pattern) {
        bq.debug.error("helper.highlight : No node || pattern", o);
        return;
      }

      // support wrapping multiple patterns
      o.pattern = $.isArray(o.pattern) ? o.pattern : [o.pattern];

      this.regex = this.getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
      this.traverse(o.node, this.hightlightTextNode);
    },

    hightlightTextNode: function(textNode) {
      var match, patternNode;
      if ((match = bq.helper.highlight.regex.exec(textNode.data))) {
        var wrapperNode = document.createElement(bq.helper.highlight.o.tagName);
        wrapperNode.className = bq.helper.highlight.o.className;

        patternNode = textNode.splitText(match.index);
        patternNode.splitText(match[0].length);
        wrapperNode.appendChild(patternNode.cloneNode(true));

        textNode.parentNode.replaceChild(wrapperNode, patternNode);
      }

      return !!match;
    },

    traverse: function(el, hlTextNode) {
      var childNode, TEXT_NODE_TYPE = 3;

      for (var i = 0; i < el.childNodes.length; i++) {
        childNode = el.childNodes[i];

        if (childNode.nodeType === TEXT_NODE_TYPE) {
          i += hlTextNode(childNode) ? 1 : 0;
        }

        else {
          this.traverse(childNode, hlTextNode);
        }
      }
    },

    getRegex: function(patterns, caseSensitive, wordsOnly) {
      var escapedPatterns = [], regexStr;

      for (var i = 0; i < patterns.length; i++) {
        escapedPatterns.push(this.escapeRegExChars(patterns[i]));
      }

      regexStr = wordsOnly ?
        '\\b(' + escapedPatterns.join('|') + ')\\b' :
        '(' + escapedPatterns.join('|') + ')';

      return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, 'i');
    },

    escapeRegExChars: function(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

  },

  validation: {
    setError: function(input, text) {
      this.setStatus(input, 'error', text);
    },

    setSuccess: function(input, text, fade) {
      var $success = 'success';
      if(text) { $success = 'success-warning'; }

      this.setStatus(input, $success, text, fade);
    },

    setWarning: function(input, text) {
      this.setStatus(input, 'warning', text);
    },

    setLoading: function(input) {
      this.setStatus(input, 'loading');
    },

    setStatus: function(input, type, text, fade, forcedIcon) {
      this.clearStatus(input);

      var $parent = $(input).parent();
      var classes = '';
      var iconClasses = '';
      var faClass = '';

      switch(type) {
        case "warning":
          classes = 'has-warning has-feedback';
          iconClasses = 'fa text-warning form-control-feedback';
          faClass = 'fa-exclamation-triangle';
          break;
        case "error":
          classes = 'has-error has-feedback';
          iconClasses = 'fa text-error form-control-feedback';
          faClass = 'fa-times';
          break;
        case "loading":
          classes = 'has-feedback';
          iconClasses = 'fa fa-spin text-muted form-control-feedback';
          faClass = 'fa-refresh';
          break;
        case "success-warning":
          classes = 'has-success has-feedback';
          iconClasses = 'fa text-warning form-control-feedback';
          faClass = 'fa-exclamation-triangle';
          break;
        default:
          classes = 'has-success has-feedback';
          iconClasses = 'fa text-success form-control-feedback';
          faClass = 'fa-check';
          break;
      }

      if (typeof forcedIcon !== "undefined") {
          faClass = forcedIcon;
      }

      iconClasses += " " + faClass;

      var $icon = $('<span></span>').addClass(iconClasses);
      $parent.append($icon).addClass(classes);

      if(fade) {
        var $input = input;
        var $this = this;
        $icon.delay(1500).fadeOut(500).promise().done(function(){ $this.clearStatus($input); });
      }

      if(text) {
        $icon.tooltip({
          title: text
        });
      }

    },

    clearStatus: function(input) {
      var $parent = $(input).parent();

      $parent.removeClass('has-success has-feedback has-error has-warning has-info');
      $('.form-control-feedback', $parent).tooltip('destroy').remove();
    }
  },

  quickView: function(pid, url) {
    var customId = 'product_modal_'+pid;

    if(this.modal.modals[customId]) {
      this.modal.modals[customId].modal('show');
    } else {
      this.modal.create(customId, url, false, false, false, {'.modal-dialog': 'modal-fluid'});
    }

  },

  ajaxModal: function(url, cssClass) {
    if (!cssClass) {
      cssClass = 'modal-fluid';
    }

    //need to figure out how to cache this
    var customId = 'ajax_modal_'+( ++this.uniqueIdCounter );

    if(this.modal.modals[customId]) {
      this.modal.modals[customId].modal('show');
    } else {
      this.modal.create(customId, url, false, false, false, {'.modal-dialog': cssClass});
    }

  },

  infoModal: function(pid, url, title) {
    //need to figure out how to cache this
    var customId = 'info_modal_'+pid;

    if(this.modal.modals[customId]) {
      this.modal.modals[customId].modal('show');
    } else {
      this.modal.create(customId, url, title, false, false, {'.modal-dialog': 'modal-fluid'}, true);
    }
  },

  customModal: function(pid, action, remote, remoteUrl) {
    var customId = 'info_modal_'+pid;//pid - html id of custom created modal in html
    if(!this.modal.modals[customId]) {
        this.modal.modals[customId] = $('#' + pid).modal({});
    }
    if (remote) {
      var loadUrl = remoteUrl || action;
      $('#' + pid + ' .modal-body').html(this.getModalLoadingHtml());
      $('#' + pid + ' .modal-body').load(loadUrl);
    }
    if (this.modal.modals[customId].find('form')) {
        this.modal.modals[customId].find('form').trigger('reset');
        this.modal.modals[customId].find('form').attr('action', action);
    }
    this.modal.modals[customId].modal('show');
  },

  getModalLoadingHtml: function() {
    var loadingMessage = (bq.messages && bq.messages.global && bq.messages.global.loading)
      ? bq.messages.global.loading
      : 'Please wait...';
    var isNewDesign = $('body').is('.theme-new, .light-theme, .dark-theme');

    if (isNewDesign) {
      return '<div data-view-handler-loading="" class="view-handler-loading"><div class="view-handler-loading-inner"><span class="view-handler-icon-wrap"><span class="loader"></span></span><div data-view-handler-message="" class="view-handler-message">' + loadingMessage + '</div></div></div>';
    }

    return '<div class="loading"><p><span class="fa fa-spinner fa-spin"></span> ' + loadingMessage + '</p></div>';
  },

  /**
   * can be used for any entity
   * implement callback method prepareAroundRequest is required
   *
   * @param $this
   * @param params
   * @param el
   */
  timeoutAjaxProcess: function($this, params, el) {
    var timeoutDelay = 1000;
    // storage all elements
    var elementId = params.id;
    bq.elementStorage[elementId] = {
      'element': $this,
      'params': params,
    };

    clearTimeout(bq.timeoutAjaxDelay);

    var self = $this;
    bq.timeoutAjaxDelay = setTimeout(function addAjaxAction() {

      //check if add ajax in process
      if (bq.isAjaxInProcess == true) {

        //wait more
        bq.timeoutAjaxDelay = setTimeout(addAjaxAction, timeoutDelay);
      } else {

        //copy data to local storage and clear global
        var localElementStorage = bq.elementStorage;
        bq.elementStorage = {};

        //set ajax as in process
        bq.isAjaxInProcess = true;

        //[[prepare ajax request
        var ajaxRequest = $this.options.prepareAroundRequest(params, localElementStorage);
        //prepare request]]

        $.post(self.options.ajaxUrl, ajaxRequest, function (data, textStatus) {
        }, 'json')
            .done(function (json) {
              var type = 'success';
              if (json instanceof Object) {
                var responseObj = json;
              } else {
                var responseObj = JSON.parse(json);
              }
              //[[process each response

              if (responseObj.error && responseObj.error === 'true' && responseObj.itemId) {
                localElementStorage[responseObj.itemId].element._notify('error', responseObj.message);
              } else {
                for (var response in responseObj) {
                  if (response == 'item') {
                    for (var item in responseObj[response]) {
                      localElementStorage[item].element._notify(type, responseObj[response][item].message);
                    }
                  }

                  var itemId = responseObj[response].itemId;
                  if (!localElementStorage.hasOwnProperty(itemId)) {
                    continue;
                  }

                  if (responseObj[response].error === true || responseObj[response].error === 'true') {
                    type = 'error';
                  } else if (responseObj[response].forward) {
                    //if forward is set, redirect to first
                    window.location = responseObj[response].forward;
                    type = 'loading';
                  }
                  localElementStorage[itemId].element._notify(type, responseObj[response].message);

                  if (responseObj[response].notifications) {
                    $.each(responseObj[response].notifications, function (k, notification) {
                      bq.helper.throwEvent('bq.notification', $('body'), $.extend(notification, {id: 'notification_' + k}));
                    });
                  }
                }
              }
              //process each response]]

              if (responseObj.update) {
                if (typeof(responseObj.update) === 'object') {
                  $.each(responseObj.update, function (k, v) {
                    if (v.target) {
                      $(v.target).html(v.html);
                    }
                  });
                } else if (responseObj.update.target && responseObj.update.html) {
                  $(responseObj.update.target).html(responseObj.update.html);
                }
              }
              $this.options.callbackSuccess(json, el);
            })
            .fail(function (jqxhr, textStatus, error) {

              var err = textStatus + ", " + error;
              bq.debug.error("Inline Update : update : ajax error : " + err, this);

              if (jqxhr instanceof Object) {
                var responseObj = jqxhr;
              } else {
                var responseObj = JSON.parse(jqxhr);
              }

              for (var response in responseObj) {
                var itemId = responseObj[response].itemId;
                if (!localElementStorage.hasOwnProperty(itemId)) {
                  continue;
                }

                var element = localElementStorage[itemId].element;
                element._notify('error');
                element.options.callbackFail(jqxhr, textStatus, error);
              }
            })
            .always(function (json, textStatus, jqXHR) {

              if (json instanceof Object) {
                var responseObj = json;
              } else {
                var responseObj = JSON.parse(json);
              }

              //[[process each response
              for (var response in responseObj) {
                var itemId = responseObj[response].itemId;
                if (!localElementStorage.hasOwnProperty(itemId)) {
                  continue;
                }

                var element = localElementStorage[itemId].element;
                element._enable();
                element._callBackAlways(json, textStatus, jqXHR);
                element.options.callbackAlways(json, textStatus, jqXHR);
                bq.helper.throwEvent(element.events.throwDone, element.$element);
              }
              //process each response]]

              //set ajax as not in process
              bq.isAjaxInProcess = false;
            });
      }
    }, timeoutDelay);
  },

  modal: {
    modals: {},
    templates: {
      container: '<div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"></div></div></div>',
      header: '<div class="modal-header"><button id="bqat-btnDismissModal" type="button" class="close" data-dismiss="modal">&times;</button><div class="h4 modal-title"></div></div>',
      content: '<div class="modal-body"></div>',
      footer: '<div class="modal-footer"></div>'
    },
    options: {

    },
    create: function(id, url, title, content, footer, classes, useLoad){
      var $modal = $(this.templates.container).attr('id', id);
      //attach the header
      if(title) {
        $modal.find('.modal-content').append($(this.templates.header)).find('.modal-title').html(title);
      }

      //attach loading
      $modal.find('.modal-content').append($(this.templates.content));
      $modal.find('.modal-body').html(bq.helper.getModalLoadingHtml());

      //attach the footer
      if(footer) {
        $modal.find('.modal-content').append($(this.templates.footer)).find('.modal-footer').html(footer);
      }

      //attach the content
      if(content) {
        $modal.find('.modal-body').html(content);
      }

      //assign extra classes
      if(classes) {
        $.each(classes, function(k,v) {
          $modal.find(k).addClass(v);
        });
      }

      //append to the body, then show
      $('body').append($modal);
      if(url) {
        if(!useLoad) {
          $modal.modal({remote: url});
        } else {
          $modal.modal({});
          $modal.find('.modal-body').load(url);
        }
      } else {
        $modal.modal({});
      }
      this.modals[id] = $modal;
    }
  },

  cookies: {
    getItem: function (sKey) {
      var c = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
      bq.debug.log('Getting Cookie: '+sKey, c);
      return c;
    },
    setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
      if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
      var sExpires = "";
      if (vEnd) {
        switch (vEnd.constructor) {
          case Number:
            sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
            break;
          case String:
            sExpires = "; expires=" + vEnd;
            break;
          case Date:
            sExpires = "; expires=" + vEnd.toUTCString();
            break;
        }
      }
      var c = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
      document.cookie = c;
      bq.debug.log('Setting Cookie: '+sKey, c);
      return true;
    },
    removeItem: function (sKey, sPath, sDomain) {
      if (!sKey || !this.hasItem(sKey)) { return false; }
      document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + ( sDomain ? "; domain=" + sDomain : "") + ( sPath ? "; path=" + sPath : "");
      return true;
    },
    hasItem: function (sKey) {
      return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
    }
  },

  browser: {
    isSupported: function(){

      //For now only checking if IE and if it's less than version 10
      var unsupported = ['MSIE 9', 'MSIE 8', 'MSIE 7'],
        userAgent = window.navigator.userAgent,
        supportedResult = true;

      for (var i = 0; i < unsupported.length; i++) {
        var _regEx = new RegExp(unsupported[i])
        if(_regEx.test(userAgent)) {
          supportedResult = false;
        }
      }

      return supportedResult;
    }
  },

  escapeHtml: function(str) {
    var result = str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
    return result;
  },

  getExactDivision: function(dividend, divisor) {
    var divideEpsilon = divisor / 100000,
      remainder = dividend % divisor;
    if (Math.abs(remainder - divisor) < divideEpsilon || Math.abs(remainder) < divideEpsilon) {
      remainder = 0;
    }
    return remainder;
  },

  checkInitiator(searchString, stackSize = false) {
    if (stackSize !== false) {
      Error.stackTraceLimit = stackSize;
    }
    var stackArray = (new Error()).stack.split("\n");
    var initElement = stackArray.pop();
    return initElement.indexOf(searchString) !== -1;
  }
};

bq.helper.stickyBanner();
